module.exports = require('../internals/global');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/path.js
// module id = 257
// module chunks = 168707334958949